import withAutoComplete from 'src/wiredComponent/HOC/withAutoComplete';
import AutoComplete from '../../components/Autocomplete';

const WiredAutoComplete = withAutoComplete(AutoComplete)

export default WiredAutoComplete;